import { c as _c } from "react/compiler-runtime";
import { createContext, useState, useContext } from 'react';
const CursorContext = createContext({
  isHovering: false,
  setIsHovering: value => {}
});
export const CursorProvider = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [isHovering, setIsHovering] = useState(false);
  let t1;
  if ($[0] !== isHovering) {
    t1 = {
      isHovering,
      setIsHovering
    };
    $[0] = isHovering;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <CursorContext.Provider value={t1}>{children}</CursorContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useCursor = () => {
  return useContext(CursorContext);
};